import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import Snackbar from '~/components/@extended/Snackbar';
import Locales from '~/components/Locales';
import RTLLayout from '~/components/RTLLayout';
import ScrollTop from '~/components/ScrollTop';
import { FlagsProvider } from '~/components/flags/FlagsProvider';
import Notistack from '~/components/third-party/Notistack';
import { ApolloAuthProvider } from '~/contexts/ApolloAuthProvider';
import { JWTProvider as CognitoAuthProvider } from '~/contexts/JWTContextCognito';
import router from '~/routes';
import { ThemeProvider } from '~/themes/ThemeProvider';

import LaunchDarklyUserIdentifier from './components/flags/LaunchDarklyUserIdentifier';

const queryClient = new QueryClient();

// @ts-ignore
window.hideIntercom = () => {
  const intercom = document.querySelector('.intercom-lightweight-app');
  if (intercom) {
    // @ts-ignore
    intercom.style.setProperty('display', 'none');
  }
  return !!intercom;
};

// @ts-ignore
window.persistentHideIntercom = () => {
  // @ts-ignore
  const success = window.hideIntercom();

  if (!success) {
    setTimeout(() => {
      // @ts-ignore
      window.persistentHideIntercom();
    }, 500);
  }
};

// @ts-ignore
window.logVersion = () => {
  console.log(`Commit Hash: https://github.com/topsteptrader/trm/commit/${process.env.commit}`);
};

const App = () => {
  const AuthProvider = CognitoAuthProvider;

  useEffect(() => {
    if (process.env.HIDE_INTERCOM) {
      // @ts-ignore
      window.persistentHideIntercom();
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LaunchDarklyUserIdentifier>
          <ApolloAuthProvider>
            <ThemeProvider>
              <RTLLayout>
                <FlagsProvider>
                  <Locales>
                    <ScrollTop>
                      <Notistack>
                        <RouterProvider router={router} />
                        <Snackbar />
                      </Notistack>
                    </ScrollTop>
                  </Locales>
                </FlagsProvider>
              </RTLLayout>
            </ThemeProvider>
          </ApolloAuthProvider>
        </LaunchDarklyUserIdentifier>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
